import { DriverDto } from '@fleet-beat/api';

export interface TransferOutputFileDto {
  comment?: string;
  driver?: DriverDto;
  type?: string;
  dateRange?: string;
}
